import { useOrganization } from "../context/OrganizationContext";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { Building2 } from "lucide-react";

export function OrganizationSwitcher() {
    const { currentOrg, organizations, switchOrg, isLoading } = useOrganization();

    // Don't show if loading or only 1 org (and it's not a generic container requiring context confirmation)
    // Actually, seeing the current org is useful even if it's the only one, 
    // but standard practice is often to hide if single tenant. 
    // For this multi-tenant app, showing context is good.
    // Docs said: "if (organizations.length <= 1) return null;"
    // But let's verify if that's desired. If I'm an admin of 1 org, I might still want to see which one it is.
    // However, specifically following the spec from the previous agent (Phase 4.2):
    // "if (organizations.length <= 1) return null;"

    if (isLoading) return null;
    if (organizations.length <= 1) return null;

    return (
        <div className="flex items-center mr-2">
            <Select
                value={currentOrg?.id?.toString()}
                onValueChange={(value) => switchOrg(Number(value))}
            >
                <SelectTrigger className="w-[180px] h-9 gap-2">
                    <Building2 className="h-4 w-4" />
                    <SelectValue placeholder="Select Organization">
                        {currentOrg?.name || "Select Org"}
                    </SelectValue>
                </SelectTrigger>
                <SelectContent>
                    {organizations.map((org) => (
                        <SelectItem key={org.id} value={org.id.toString()}>
                            {org.name}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
